<div class="banner text-center">
   <p class="bg-secondary p-2  text-brown">Free Shipping + Extra 10% Off on Prepaid Order</p>
</div>